module.exports = __webpack_public_path__ + "static/media/studio-slide9.3b6bf8b9.png";